import clsx from 'clsx';
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavItemProps } from './NavItem';

export const NavDropdownItem = ({ path, name, children, onClick }: React.PropsWithChildren<NavItemProps>) => {
  const location = useLocation();
  const selected = path === location.pathname;
  return (
    <div className='flex flex-col'>
      <Link
        data-testid={`${name}Link`}
        to={path}
        onClick={onClick}
        className={clsx(
          'text-black-default inline-flex w-full h-full flex-col',
          'p-3 px-4 text-base leading-tight transition-colors duration-300',
          'hover:no-underline hover:font-semibold focus:outline-none min-w-12',
          selected && 'font-semibold',
          !selected && 'hover:text-secondary-500'
        )}
      >
        {children}
      </Link>
      {selected && (
        <div className='w-full bg-secondary-500 px-2' style={{ position: 'relative', bottom: '-1px', height: '2px' }} />
      )}
    </div>
  );
};
